import { useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useMutation } from '@apollo/react-hooks'
import { useLocation, useHistory } from 'react-router-dom'
import { useIntl } from 'react-intl'
import queryString from 'query-string'
import { SHOW as ALERTSNACKBARSHOW } from 'reducer/alertSnackbar'
import { SHOW as BACKDROPSHOW, HIDE as BACKDROPHIDE } from 'reducer/backdrop'
import { MOUNT } from 'reducer/loginMount'
import { CREATE_LOGIN } from 'gql/token'
import { cookies } from 'utils'
import useLandingPage from 'hooks/useLandingPage'

// refere 허용가능한  domain list
let isOrigin = [
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_LANDING_DOMAIN}`,
    `${process.env.REACT_APP_PROTOCOL}://www.${process.env.REACT_APP_LANDING_DOMAIN}`,
    `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_RESPOND_DOMAIN}`
]

if (process.env.NODE_ENV === 'development') isOrigin = [...isOrigin, 'http://localhost:3002']

let mount = false

function IngContainer() {
    const [ login ] = useMutation(CREATE_LOGIN)

    const getLandingPage = useLandingPage()

    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation()

    const search = queryString.parse(location.search)
    const encrypt= search.encrypt
    const redirect_url = search.redirect_url ? `${search.redirect_url}${location.hash}` : '/workspace'

    const { formatMessage: f } = useIntl()

    const handleSubmit = useCallback(async() => {
        // 한번만 호출되게 처리
        if (mount) return
        
        mount = true
        function fail() {
            dispatch({ 
                type: ALERTSNACKBARSHOW, 
                message: f({id: 'container.Login.Ing.fail'}), 
                variant: 'error', 
                duration: 3500
            })

            setTimeout(() => {
                window.location.assign(getLandingPage())
            }, 1500)

        }

        // listovey.com 에서 온건지 체크
        const origins = isOrigin.map(c => `${c}/`).join('|')

        if (!new RegExp(origins).test(window.document.referrer)) {
            fail()
            return
        }

        try {    
            const { data } = await login({variables: { encrypt }})

            if (!data.login.token) fail()
            
            dispatch({ type: BACKDROPSHOW })
            localStorage.setItem('authorization', data.login.token)
            
            // 개발 서버에서 localhost로 접속시 쿠키를 localhost 로 굽거 아니면 default인 .listovey.com 으로 굽느다
            const domain = new RegExp('localhost').test(window.document.referrer) ? 'localhost' : undefined

            cookies.set({ value: 'Logined=true', expires: 0, domain })
        
            dispatch({ type: MOUNT, mount: Math.random() })
            dispatch({ type: BACKDROPHIDE })
            setTimeout(async () => {
                history.push(redirect_url)
            }, 100)            
        } catch(e) {

            fail()
        } finally {
            dispatch({type: BACKDROPHIDE})
        }

    }, [encrypt, redirect_url, dispatch, history, f, login, getLandingPage])

    useEffect(() => {
        handleSubmit()
    }, [handleSubmit])

    return null
}

export default IngContainer